export const UPDATE_VISION = 'updateVision'
export const UPDATE_WIDTH = 'updateWidth'
export const SET_VISION = 'setVision'
export const SET_VIEWS = 'setViews'
